var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPuzzle = function SvgPuzzle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    x: 2,
    y: 2,
    fill: "#E2FFEA",
    rx: 18
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    x: 2,
    y: 2,
    stroke: "#F4FFF7",
    strokeWidth: 4,
    rx: 18
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#51C394",
    d: "M29.04 20.13c-.14 0-.28.06-.39.17l-1 1 2.05 2.05 1-1c.22-.21.22-.56 0-.77l-1.28-1.28a.53.53 0 0 0-.38-.17m-1.97 1.75L21 27.94V30h2.06l6.06-6.07zm-8.02 5.18c-.18-.06-.36-.06-.55-.06-1.5 0-2.7 1.21-2.7 2.7v.3H12a2 2 0 0 1-2-2v-3.8h.3c1.49 0 2.7-1.2 2.7-2.7s-1.21-2.7-2.7-2.7H10V15c0-1.1.9-2 2-2h3.04c.24-1.7 1.7-3 3.46-3s3.22 1.3 3.46 3H25a2 2 0 0 1 2 2v3.04c.36.05.69.17 1 .32-.27.14-.54.3-.76.53L26.12 20H25v-5h-5v-1.5c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5V15h-5v2.12c1.76.68 3 2.38 3 4.38s-1.25 3.7-3 4.38V28h2.12a4.7 4.7 0 0 1 4.38-3c.76 0 1.5.18 2.11.5z"
  })));
};
export default SvgPuzzle;